import { Store, select } from '@ngrx/store';

import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from '@angular/router';

import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { userReducers } from '../../@store';
import { MwUserService } from '../user.service';

@Injectable()
export class ModuleAccessGuard implements CanActivate {
  constructor(
    private readonly store: Store<any>,
    private readonly userService: MwUserService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.store.pipe(
      select(userReducers.hasAccess),
      map((hasAccess) => {
        if (!hasAccess) {
          this.userService.changeCompany();
          return false;
        }
        return true;
      }),
      take(1)
    );
  }
}
